module.exports = __webpack_public_path__ + "img/1293971481.a105de98.jpg";